import { render, staticRenderFns } from "./XeroPayments.vue?vue&type=template&id=0875331d&"
import script from "./XeroPayments.vue?vue&type=script&lang=js&"
export * from "./XeroPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports